// src/services/api/clinicService.ts
import { api } from "./api";
import type { CustomRequestConfig } from "../../types/api";
import type { IClinic } from "../../types/clinic";
import { config } from "../../config/environment";

//const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const defaultClinicId = config.clinic.id;

export const clinicService = {
  // Public endpoint - getting basic clinic info
  getClinicById: async (clinicId: string = defaultClinicId) => {
    const response = await api.get<IClinic>(`/clinics/${clinicId}`);
    return response.data;
  },

  // Public endpoint - getting contact info
  getClinicContactInfo: async (clinicId: string = defaultClinicId) => {
    const response = await api.get<IClinic>(`/clinics/${clinicId}/contact`);
    return response.data;
  },

  // Protected endpoint - updating contact info
  updateClinicContactInfo: async (
    clinicId: string = defaultClinicId,
    contactInfo: Partial<IClinic>
  ) => {
    const config: CustomRequestConfig = {
      requireAuth: true,
    };

    const response = await api.patch<IClinic>(
      `/clinics/${clinicId}/contact`,
      contactInfo,
      config
    );
    return response.data;
  },
};
